import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UseMutationCallbacks } from '#shared/model'
import { TG_TOKENS_QUERY_KEY } from '#shared/state/tg-tokens-query'
import createUser from '../api/create-user'

export default function useCreateUserMutation(callbacks: UseMutationCallbacks) {
  const queryClient = useQueryClient()

  return useMutation({
    ...callbacks,

    mutationFn: createUser,

    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: TG_TOKENS_QUERY_KEY })

      callbacks.onSuccess?.()
    },
  })
}
